import React from 'react';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { Redirect } from '@atlassian/react-resource-router';

const RedirectToPrettyUrlTrashDirectory = (): React.JSX.Element => (
	<ContextualAnalyticsData sourceType={SCREEN} sourceName="projectsTrashRedirect">
		<Redirect to="/jira/settings/projects/trash" />
		<FireScreenAnalytics />
	</ContextualAnalyticsData>
);

export default RedirectToPrettyUrlTrashDirectory;
